(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "./formField"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("./formField"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.formField);
    global.RadioButtonField = mod.exports;
  }
})(this, function (_exports, _propTypes, _react, _formField) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = _exports.RadioButtonFieldRaw = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _formField = _interopRequireDefault(_formField);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  var RadioButtonFieldRaw =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(RadioButtonFieldRaw, _React$Component);

    function RadioButtonFieldRaw() {
      _classCallCheck(this, RadioButtonFieldRaw);

      return _possibleConstructorReturn(this, _getPrototypeOf(RadioButtonFieldRaw).apply(this, arguments));
    }

    _createClass(RadioButtonFieldRaw, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            value = _this$props.value,
            _onChange = _this$props.onChange,
            name = _this$props.name,
            scopedName = _this$props.scopedName,
            buttons = _this$props.buttons,
            disabled = _this$props.disabled,
            other = _objectWithoutProperties(_this$props, ["value", "onChange", "name", "scopedName", "buttons", "disabled"]);

        return _react["default"].createElement("div", other, buttons.map(function (button, index) {
          return _react["default"].createElement("span", {
            key: button.value
          }, _react["default"].createElement("input", {
            id: scopedName + '.' + index,
            name: scopedName,
            type: "radio",
            value: index,
            onChange: function onChange(event) {
              return _onChange(buttons[parseInt(event.target.value)].value);
            },
            checked: value === button.value,
            disabled: disabled
          }), _react["default"].createElement("label", {
            htmlFor: scopedName + '.' + index
          }, button.label));
        }));
      }
    }]);

    return RadioButtonFieldRaw;
  }(_react["default"].Component);

  _exports.RadioButtonFieldRaw = RadioButtonFieldRaw;

  _defineProperty(RadioButtonFieldRaw, "propTypes", {
    value: _propTypes["default"].any.isRequired,
    onChange: _propTypes["default"].func.isRequired,
    name: _propTypes["default"].string,
    scopedName: _propTypes["default"].string,
    buttons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].any.isRequired,
      label: _propTypes["default"].string.isRequired
    })).isRequired,
    disabled: _propTypes["default"].bool
  });

  _defineProperty(RadioButtonFieldRaw, "defaultProps", {
    disabled: false
  });

  var _default = (0, _formField["default"])()(RadioButtonFieldRaw);

  _exports["default"] = _default;
});